export const getOidcInfoURL = () => {
  const oidcUri = localStorage.getItem("oidcUri");
  const oidcConfiguration = JSON.parse(localStorage.getItem("oidcConfiguration"));

  var userInfoURL = `${JSON.parse(oidcUri)}protocol/openid-connect/userinfo`
  if (oidcConfiguration && oidcConfiguration.userInfo) {
    userInfoURL = oidcConfiguration.userInfo;
  }
  return userInfoURL;
}

export const getOidcTokenURL = () => {
  const oidcUri = localStorage.getItem("oidcUri");
  const oidcConfiguration = JSON.parse(localStorage.getItem("oidcConfiguration"));

  var tokenURL = `${JSON.parse(oidcUri)}protocol/openid-connect/token`
  if (oidcConfiguration && oidcConfiguration.token) {
    tokenURL = oidcConfiguration.token;
  }
  return tokenURL
}

export const getAzureHybridLoginURL = () => {
  const oidcConfiguration = JSON.parse(localStorage.getItem("oidcConfiguration"));
  var url = `${oidcConfiguration.auth}?client_id=${oidcConfiguration.clientId}&response_mode=fragment&redirect_uri=${window.origin}/console/home`
  url = `${url}&response_type=${encodeURI("code id_token")}`
  const scopes = encodeURI(oidcConfiguration.scopes.join(' '))
  url = `${url}&scope=${scopes}&nonce=abcde`
  return url
}
